import {ref, computed, effect, html, clone, traverse, on, after, text, show, attr, class_toggle, each, append, css, define} from "@intrnl/velvet/internal";
import './style.css';
let template0 = html("<header class=header> <h1>todos</h1> <input class=new-todo placeholder='What needs to be done?' autofocus /> </header> <!>");
let template1 = html("<section class=main> <input id=toggle-all class=toggle-all type=checkbox /> <label for=toggle-all>Mark all as complete</label> <ul class=todo-list> <!> </ul> <footer class=footer> <span class=todo-count> <strong><!></strong> <!> left </span> <ul class=filters> <li><a href=#/>All</a></li> <li><a href=#/active>Active</a></li> <li><a href=#/completed>Completed</a></li> </ul> <!> </footer> </section>");
let template2 = html("<li> <div class=view> <input class=toggle type=checkbox /> <label> <!> </label> <button class=destroy></button> </div> <!> </li>");
let template3 = html("<input class=edit />");
let template4 = html("<button class=clear-completed> Clear completed </button>");
let style0 = css("button{margin:0;padding:0;border:0;background:none;font-size:100%;vertical-align:baseline;font-family:inherit;font-weight:inherit;color:inherit;appearance:none}.hidden{display:none}:host{display:block;background:#fff;margin:130px 0 40px;position:relative;box-shadow:0 2px 4px #0003,0 25px 50px #0000001a}input::placeholder{font-style:italic;font-weight:400;color:#0006}h1{position:absolute;top:-140px;width:100%;font-size:80px;font-weight:200;text-align:center;color:#b83f45;text-rendering:optimizeLegibility}.new-todo,.edit{position:relative;margin:0;width:100%;font-size:24px;font-family:inherit;font-weight:inherit;line-height:1.4em;color:inherit;padding:6px;border:1px solid #999;box-shadow:inset 0 -1px 5px #0003;box-sizing:border-box}.new-todo{padding:16px 16px 16px 60px;height:65px;border:none;background:rgba(0,0,0,.003);box-shadow:inset 0 -2px 1px #00000008}.main{position:relative;z-index:2;border-top:1px solid #e6e6e6}.toggle-all{width:1px;height:1px;border:none;opacity:0;position:absolute;right:100%;bottom:100%}.toggle-all+label{display:flex;align-items:center;justify-content:center;width:45px;height:65px;font-size:0;position:absolute;top:-65px;left:-0}.toggle-all+label:before{content:\"\\276f\";display:inline-block;font-size:22px;color:#949494;padding:10px 27px;transform:rotate(90deg)}.toggle-all:checked+label:before{color:#484848}.todo-list{margin:0;padding:0;list-style:none}.todo-list li{position:relative;font-size:24px;border-bottom:1px solid #ededed}.todo-list li:last-child{border-bottom:none}.todo-list li.editing{border-bottom:none;padding:0}.todo-list li.editing .edit{display:block;width:calc(100% - 43px);padding:12px 16px;margin:0 0 0 43px}.todo-list li.editing .view{display:none}.todo-list li .toggle{text-align:center;width:40px;height:auto;position:absolute;top:0;bottom:0;margin:auto 0;border:none;-webkit-appearance:none;appearance:none}.todo-list li .toggle{opacity:0}.todo-list li .toggle+label{background-image:url(/assets/checkbox.svg);background-repeat:no-repeat;background-position:center left}.todo-list li .toggle:checked+label{background-image:url(/assets/checkbox-checked.svg)}.todo-list li label{word-break:break-all;padding:15px 15px 15px 60px;display:block;line-height:1.2;transition:color .4s;font-weight:400;color:#484848}.todo-list li.completed label{color:#949494;text-decoration:line-through}.todo-list li .destroy{display:none;position:absolute;top:0;right:10px;bottom:0;width:40px;height:40px;margin:auto 0;font-size:30px;color:#949494;transition:color .2s ease-out}.todo-list li .destroy:hover,.todo-list li .destroy:focus{color:#c18585}.todo-list li .destroy:after{content:\"\\d7\";display:block;height:100%;line-height:1.1}.todo-list li:hover .destroy{display:block}.todo-list li .edit{display:none}.todo-list li.editing:last-child{margin-bottom:-1px}.footer{padding:10px 15px;height:20px;text-align:center;font-size:15px;border-top:1px solid #e6e6e6}.footer:before{content:\"\";position:absolute;right:0;bottom:0;left:0;height:50px;overflow:hidden;box-shadow:0 1px 1px #0003,0 8px 0 -3px #f6f6f6,0 9px 1px -3px #0003,0 16px 0 -6px #f6f6f6,0 17px 2px -6px #0003}.todo-count{float:left;text-align:left}.todo-count strong{font-weight:300}.filters{margin:0;padding:0;list-style:none;position:absolute;right:0;left:0}.filters li{display:inline}.filters li a{color:inherit;margin:3px;padding:3px 7px;text-decoration:none;border:1px solid transparent;border-radius:3px}.filters li a:hover{border-color:#db7676}.filters li a.selected{border-color:#ce4646}.clear-completed,html .clear-completed:active{float:right;position:relative;line-height:19px;text-decoration:none;cursor:pointer}.clear-completed:hover{text-decoration:underline}.info{margin:65px auto 0;color:#4d4d4d;font-size:11px;text-shadow:0 1px 0 rgba(255,255,255,.5);text-align:center}.info p{line-height:1}.info a{color:inherit;text-decoration:none;font-weight:400}.info a:hover{text-decoration:underline}@media screen and (-webkit-min-device-pixel-ratio: 0){.toggle-all,.todo-list li .toggle{background:none}.todo-list li .toggle{height:40px}}@media (max-width: 430px){.footer{height:50px}.filters{bottom:10px}}:focus,.toggle:focus+label,.toggle-all:focus+label{box-shadow:0 0 2px 2px #cf7d7d;outline:0}");
function setup($$root, $$host) {
  const ENTER_KEY = 13;
  const ESCAPE_KEY = 27;
  const STORAGE_KEY = 'todos';
  const filters = {
    all: items => items,
    active: items => items.filter(item => !item.completed),
    completed: items => items.filter(item => item.completed)
  };
  let items = ref(JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'));
  let visibility = ref('all');
  let editing = ref(null);
  let editing_ref = ref(null);
  let filtered_items = computed(() => filters[visibility.v](items.v));
  let remaining = computed(() => filters.active(items.v).length);
  const toggle_all = event => {
    items.v = items.v.map(item => ({
      ...item,
      completed: event.target.checked
    }));
  };
  const clear_completed = () => {
    items.v = items.v.filter(item => !item.completed);
  };
  const add_todo = event => {
    if (event.which === ENTER_KEY) {
      items.v = items.v.concat({
        id: Date.now(),
        title: event.target.value,
        completed: false
      });
      event.target.value = '';
    }
  };
  const remove_todo = id => {
    items.v = items.v.filter(item => item.id !== id);
  };
  const edit_todo = next => {
    items.v = items.v.map(item => {
      if (item.id !== next.id) return item;
      return {
        ...item,
        ...next
      };
    });
  };
  const toggle_todo = (id, event) => {
    edit_todo({
      id,
      completed: event.target.checked
    });
  };
  const handle_edit = event => {
    if (event.which === ENTER_KEY) {
      event.target.blur();
    } else if (event.which === ESCAPE_KEY) {
      editing.v = null;
      editing_ref.v = null;
    }
  };
  const handle_submit = event => {
    edit_todo({
      id: editing.v,
      title: event.target.value
    });
    editing.v = null;
    editing_ref.v = null;
  };
  const update_view = () => {
    let route = window.location.hash.replace(/#\/?/, '');
    if (!filters[route]) {
      route = 'all';
    }
    visibility.v = route;
  };
  window.addEventListener('hashchange', update_view);
  update_view();
  effect(() => localStorage.setItem(STORAGE_KEY, JSON.stringify(items.v)));
  effect(() => {
    if (editing_ref.v) setTimeout(() => editing_ref.v.focus());
  });
  let fragment0 = clone(template0);
  let child0 = traverse(fragment0, [0, 3]);
  let marker6 = traverse(fragment0, [2]);
  let block1 = $$root => {
    let fragment1 = clone(template1);
    let child1 = traverse(fragment1, [0, 1]);
    let marker2 = traverse(fragment1, [0, 5, 1]);
    let marker3 = traverse(fragment1, [0, 7, 1, 1, 0]);
    let marker4 = traverse(fragment1, [0, 7, 1, 3]);
    let child7 = traverse(fragment1, [0, 7, 3, 1, 0]);
    let child8 = traverse(fragment1, [0, 7, 3, 3, 0]);
    let child9 = traverse(fragment1, [0, 7, 3, 5, 0]);
    let marker5 = traverse(fragment1, [0, 7, 5]);
    let child11 = traverse(fragment1, [0]);
    let block2 = ($$root, item) => {
      let fragment2 = clone(template2);
      let child2 = traverse(fragment2, [0, 1, 1]);
      let marker0 = traverse(fragment2, [0, 1, 3, 1]);
      let child3 = traverse(fragment2, [0, 1, 3]);
      let child4 = traverse(fragment2, [0, 1, 5]);
      let marker1 = traverse(fragment2, [0, 3]);
      let child6 = traverse(fragment2, [0]);
      let block3 = $$root => {
        let fragment3 = clone(template3);
        let child5 = traverse(fragment3, [0]);
        editing_ref.v = child5;
        effect(() => child5["value"] = item.v.title);
        on(child5, "keydown", handle_edit);
        on(child5, "blur", handle_submit);
        after($$root, fragment3);
        return child5;
      };
      effect(() => child2["checked"] = item.v.completed);
      on(child2, "change", event => toggle_todo(item.v.id, event));
      text(marker0, () => item.v.title);
      on(child3, "dblclick", () => editing.v = item.v.id);
      on(child4, "click", () => remove_todo(item.v.id));
      show(marker1, () => editing.v === item.v.id ? block3 : null);
      attr(child6, "class", "todo");
      effect(() => class_toggle(child6, "completed", item.v.completed));
      effect(() => class_toggle(child6, "editing", editing.v === item.v.id));
      after($$root, fragment2);
      return child6;
    };
    let block4 = $$root => {
      let fragment4 = clone(template4);
      let child10 = traverse(fragment4, [0]);
      on(child10, "click", clear_completed);
      after($$root, fragment4);
      return child10;
    };
    effect(() => child1["checked"] = remaining.v === 0);
    on(child1, "change", toggle_all);
    each(marker2, block2, () => filtered_items.v);
    text(marker3, () => remaining.v);
    text(marker4, () => remaining.v === 1 ? 'item' : 'items');
    effect(() => class_toggle(child7, "selected", visibility.v === 'all'));
    effect(() => class_toggle(child8, "selected", visibility.v === 'active'));
    effect(() => class_toggle(child9, "selected", visibility.v === 'completed'));
    show(marker5, () => items.v.length > remaining.v ? block4 : null);
    after($$root, fragment1);
    return child11;
  };
  on(child0, "keydown", add_todo);
  show(marker6, () => items.v.length > 0 ? block1 : null);
  append($$root, fragment0);
}
export default define("x-app", setup, {}, [style0]);
